import { get, post, del } from './apiHelper';

// Propuestas de contenido
export const generateProposal = async (data) => {
    return await post('social-content/propose', data);
};

// Templates
export const createTemplate = async (templateData) => {
    return await post('social-content/templates', templateData);
};

export const getTemplates = async () => {
    return await get('social-content/templates');
};

export const getTemplate = async (templateId) => {
    return await get(`social-content/templates/${templateId}`);
};

// Posts
export const createPost = async (postData) => {
    return await post('social-content/posts', postData);
};

export const getPosts = async () => {
    return await get('social-content/posts');
};

export const getPost = async (postId) => {
    return await get(`social-content/posts/${postId}`);
};

export const deletePost = async (postId) => {
    return await del(`social-content/posts/${postId}`);
};

export const renderPost = async (postId) => {
    return await post(`social-content/render/${postId}`);
};

// Generación Automática
export const generateWeeklyPosts = async (data) => {
    return await post('social-content/generate/weekly', data);
};

export const getWeeklyPosts = async (marcaId) => {
    return await get(`social-content/weekly/${marcaId}`);
};

export const approveWeeklyPost = async (postId) => {
    return await post(`social-content/weekly/${postId}/approve`);
};

export const regeneratePost = async (postId) => {
    return await post(`social-content/weekly/${postId}/regenerate`);
};

// Helper function to wait for render completion
export const waitForRender = async (postId, timeout = 30000) => {
    const startTime = Date.now();

    while (Date.now() - startTime < timeout) {
        const post = await getPost(postId);

        if (post.status === 'rendered') {
            return post;
        }

        if (post.status === 'failed') {
            throw new Error(post.metadata?.renderError || 'Render failed');
        }

        await new Promise(resolve => setTimeout(resolve, 1000));
    }

    throw new Error('Render timeout');
};

// Constants for platform dimensions
export const PLATFORM_DIMENSIONS = {
    instagram: {
        post: { width: 1080, height: 1080 },
        story: { width: 1080, height: 1920 },
        carousel: { width: 1080, height: 1080 }
    },
    facebook: {
        post: { width: 1200, height: 630 },
        story: { width: 1080, height: 1920 },
        carousel: { width: 1080, height: 1080 }
    },
    linkedin: {
        post: { width: 1200, height: 627 },
        carousel: { width: 1080, height: 1080 }
    },
    twitter: {
        post: { width: 1600, height: 900 },
        carousel: { width: 1600, height: 900 }
    }
}; 